import React from "react";

// Icons for the guest parking access page (stroke follows currentColor)
const Svg = ({ size = 24, strokeWidth = 1.8, children }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
  {children}
</svg>);

export const LockIcon = ({ size = 18 }) => (<Svg size={size}>
  <rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" />
</Svg>);

export const ClockIcon = ({ size = 20 }) => (<Svg size={size}>
  <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
</Svg>);

export const KeyIcon = ({ size = 24 }) => (<Svg size={size} strokeWidth={2}>
  <circle cx="8" cy="14" r="4" /><path d="M11 11l8-8M16 6l2 2M14 8l2 2" />
</Svg>);

export const GateIcon = ({ size = 34 }) => (<Svg size={size} strokeWidth={1.6}>
  <path d="M3 20V6M21 20V6M3 8h18M3 18h18" /><path d="M7 8v10M11 8v10M15 8v10M19 8v10" />
</Svg>);

export const DoorIcon = ({ size = 34 }) => (<Svg size={size} strokeWidth={1.6}>
  <path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17" /><path d="M4 21h16" /><circle cx="14.5" cy="12.5" r="0.9" fill="currentColor" />
</Svg>);

export const ChevronsRight = ({ size = 18 }) => (<Svg size={size} strokeWidth={2.2}>
  <path d="M6 7l5 5-5 5M13 7l5 5-5 5" />
</Svg>);
